export default class Filter {
  constructor (key, value, keyLabel = null, valueLabel = value) {
    this.key = key
    this.value = value
    this.keyLabel = keyLabel
    this.valueLabel = valueLabel
  }
}
